<template lang="pug">
.introduction
    .pages-carousel(v-if="pages.length > 0" v-touch:swipe="onSwipe")
        .introImage-container
            img.image(:src="pages[currentPageIndex].imageUrl" alt="")
        .text-container()
            div.header {{ getString(pages[currentPageIndex].header_langkey, { ns: 'configurable', defaultValue: pages[currentPageIndex].header }) }}
            div.content {{ getString(pages[currentPageIndex].content_langkey, { ns: 'configurable', defaultValue: pages[currentPageIndex].content }) }}
    .page-indicators.side-padding-32
        .page-indicator(v-for="item, $index in this.pages"
                        :key="$index"
                        :class="{active: $index === currentPageIndex}")
    .introduction-actions.side-padding-32
        aiq-button.introduction-submit(@click="nextPage" type="primary") {{ buttonMessage }}
</template>
<script>
import i18n from '../../mixins/i18n';

export default {
  name: 'introduction-component',
  mixins: [i18n],
  props: {
    introductionData: {
      type: Object,
      default: () => ({ content: '{"pages": []}' }),
    },
  },

  data() {
    const { pages } = JSON.parse(this.$props.introductionData.content);
    return {
      pages,
      currentPageIndex: 0,
      buttonMessage: this.getString('screen.introduction.next', 'Next'),
    };
  },

  methods: {
    submit() {
      this.$emit('submit');
    },

    onSwipe(event) {
      if (event.direction === 'left') {
        this.nextPage();
      } else if (event.direction === 'right') {
        this.prevPage();
      }
    },

    nextPage() {
      const currentPageIndex = this.currentPageIndex;
      if (currentPageIndex === this.pages.length - 1) {
        return this.submit();
      }
      this.currentPageIndex = (currentPageIndex + 1);
      if (this.currentPageIndex === this.pages.length - 1) {
        this.buttonMessage = this.getString('screen.introduction.get_started', 'Get Started');
      } else {
        this.buttonMessage = this.getString('screen.introduction.next', 'Next');
      }
    },

    prevPage() {
      const currentPageIndex = this.currentPageIndex;
      if (currentPageIndex === 0) {
        return;
      }
      this.currentPageIndex = (currentPageIndex - 1);
      this.buttonMessage = this.getString('screen.introduction.next', 'Next');
    },
  },
};
</script>

<style lang="scss">
.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
}

.side-padding-32 {
  padding: 0 32px;
}

.introduction {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  padding: 0 0px 15px;
  background: #fff;
  z-index: 10;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  .pages-carousel {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-grow: 1;
    overflow-y: auto;
    padding: 15px 32px 5px 32px;

    .introImage-container{
      display: flex;
      flex: 1 0px;
      align-items: flex-end;

      .image {
        height: 164px;
        display: flex;
        text-align: center;
        justify-content: center;
        margin-bottom: 24px;
        width: 210px;
      }
    }

    .text-container{
      flex: 1 0px;

      .header {
        display: flex;
        text-align: center;
        justify-content: center;
        font-weight: 500;
        font-size: 26px;
        margin-bottom: 12px;
      }

      .content {
        text-align: center;
        font-size: 18px;
        font-weight: 300;
      }
    }
  }

  .page-indicators {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 48px;

    .page-indicator {
      height: 10px;
      width: 10px;
      border: 3px solid;
      border-color: #198cfd;
      border-radius: 50%;
      margin-left: 8px;

      &.active {
        background-color: #198cfd;
      }
    }
  }

  .introduction-actions {
    display: flex;
    justify-content: center;

    .introduction-submit {
      height: 48px;
      width: 512px;
      color: #FFFFFF;
      font-weight: 500;
      span {
          color: white;
      }
    }
  }
}

</style>
